export function isOptionTemplate(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'text' in value &&
        'isNA' in value);
}
